import React, { useState } from 'react';

import { CsLpUzel, csLpUzelDelete, csLpUzelList } from '../../../api';
import List from '../../atoms/List';
import { useDialog } from '../../atoms/Dialog';
import useApi from '../../../hooks/useApi';

import FormUzel from './FormUzel';
import LoadingContainer from '../../hoc/LodingContainer';

const columns = [
    { key: 'id', label: 'ID' },
    { key: 'shorttext', label: 'Název uzlu' },
];

function Strom() {
    const { data: uzly1, call: reloadUzly, loading: loadingUzly, error: errorUzly, called: calledUzly } =
        useApi<CsLpUzel[], void>(csLpUzelList({ autoFetch: true }));
    const [vybraneUzly, setVybraneUzly] = useState<number[]>([1]);
    const { openDialog } = useDialog();

    const { call: delUzel, sending: sendingDel, error: errorDel, called: calledDel } =
        useApi<void, number>({});

    const uzelNew = (cis: number) => openDialog({
        title: 'Nová vazba',
        content:
            <FormUzel
                selUzel={cis}
                reload={reloadUzly}
                uzly={uzly} />,
        onSuccess: () => document.getElementById('form-uzel-submit')?.click()
    });

    const uzelEdit = (id: number) => openDialog({
        title: 'Upravit uzel',
        content: (
            <FormUzel
                reload={reloadUzly}
                uzly={uzly}
                data={uzly.find(item => item.id === id)} />
        ),
        onSuccess: () => document.getElementById('form-uzel-submit')?.click()
    });

    const deleteUzel =
        async (id: number) => {
            // eslint-disable-next-line no-restricted-globals
            if (!confirm(`Opravdu smazat uzel s ID ${id}?`)) return;
            if (await delUzel(csLpUzelDelete(id)) === false) return;
            reloadUzly();
        }

    const uzly = uzly1 || [];

    return (
        <>
            <h1>Strom</h1>
            <LoadingContainer loading={loadingUzly || sendingDel}
                error={errorUzly || errorDel}
                called={calledUzly || calledDel} >

                {!!uzly.length && <List
                    title='Kořen'
                    columns={columns}
                    rows={[uzly[0]]}
                    selectable='single'
                    selected={[1]}
                    onEdit={uzelEdit}
                />}

                {
                    vybraneUzly.map((id, index) => { //index - poradi seznamu uzlu
                        const uzel = uzly.find(item => item.id === id);
                        if (!uzel) return null;

                        const selected = vybraneUzly[index + 1]; //vybrano v danem seznamu

                        return (
                            <List
                                key={id}
                                title={`Potomci uzlu ${uzel.shorttext}`}
                                className='list-scroll'
                                columns={columns}
                                rows={uzly.filter(item => uzel.child?.includes(item.id))}
                                selectable='single'
                                selected={[selected]}
                                onChangeSelect={(ids) => {
                                    const out = vybraneUzly.slice(0, index + 1);
                                    if (ids.length) out.push(ids[0]);
                                    setVybraneUzly(out);
                                }}
                                onNew={() => uzelNew(vybraneUzly[index])}
                                onEdit={uzelEdit}
                                onDelete={deleteUzel}
                            />
                        );
                    })
                }
            </LoadingContainer>
        </>
    );
}

export default Strom;
